import { render } from "./TtsDialog.vue?vue&type=template&id=32d3d58c&scoped=true"
import script from "./TtsDialog.vue?vue&type=script&lang=js"
export * from "./TtsDialog.vue?vue&type=script&lang=js"

import "./TtsDialog.vue?vue&type=style&index=0&id=32d3d58c&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d3d58c"]])

export default __exports__